/* Defining a constant called ROLE. */
export const ROLE = {
    ADMINISTRADOR: { value: 1, label: 'ADMINISTRADOR' },
    MESA_DE_AYUDA: { value: 2, label: 'MESA DE AYUDA' },
    EJECUTIVO: { value: 3, label: 'EJECUTIVO' },
    MESA_DE_APROBACION: { value: 4, label: 'MESA DE APROBACIÓN' },
    APROBADOR: { value: 5, label: 'APROBADOR' },
    AUXILIAR_CARTERA: { value: 6, label: 'AUXILIAR CARTERA' },
    TESORERIA: { value: 7, label: 'TESORERIA' },
    COORDINADOR_DE_CREDITO: { value: 8, label: 'COORDINADOR DE CRÉDITO' },
    DIRECTOR_ZONA: { value: 9, label: 'DIRECTOR ZONA' },
    COORDINADOR_MESA_DE_AYUDA: {
        value: 10,
        label: 'COORDINADOR MESA DE AYUDA',
    },
    ALIADO: { value: 11, label: 'ALIADO' },
    ASESOR_COMERCIAL: { value: 12, label: 'ASESOR COMERCIAL' },
    DIRECTOR_DE_RIESGOS: { value: 15, label: 'DIRECTOR DE RIESGOS' },
    DIRECTOR_REGIONAL: { value: 16, label: 'DIRECTOR REGIONAL' },
    CONTABILIDAD: { value: 17, label: 'CONTABILIDAD' },
    JEFE_DE_SALA_DE_VENTAS: { value: 18, label: 'JEFE DE SALA DE VENTAS' },
    AUDITOR: { value: 19, label: 'AUDITOR' },
    DESARROLLO_SOCIAL: { value: 20, label: 'DESARROLLO SOCIAL' },
    CARTERA: { value: 21, label: 'CARTERA' },
    ORIGINADOR: { value: 22, label: 'ORIGINADOR' },
    GERENCIA: { value: 23, label: 'GERENCIA' },
    ARCHIVO: { value: 24, label: 'ARCHIVO' },
    ALIADO_DIGITAL: { value: 25, label: 'ALIADO DIGITAL' },
    SUPERVISOR_LEGALIZACION: { value: 26, label: 'SUPERVISOR LEGALIZACIÓN' },
    GESTION_HUMANA: { value: 27, label: 'GESTION HUMANA' },
    SEGUROS: { value: 28, label: 'SEGUROS' },
    OPERACIONES: { value: 29, label: 'OPERACIONES' },
    GERENTE_FINANCIERO: { value: 30, label: 'GERENTE FINANCIERO' },
    GERENTE_DE_OPERACIONES: { value: 31, label: 'GERENTE DE OPERACIONES' },
    DIRECTOR_DE_MERCADO: { value: 32, label: 'DIRECTOR DE MERCADO' },
    DIRECTOR_ADMINISTRATIVO: { value: 33, label: 'DIRECTOR ADMINISTRATIVO' },
    ASESOR_LEGAL: { value: 34, label: 'ASESOR LEGAL' },
    SOPORTE: { value: 35, label: 'SOPORTE' },
    ALIADO_GESTOR: { value: 39, label: 'ALIADO GESTOR' },
};

/* Defining a constant called PRODUCTOS. */
export const PRODUCTOS = {
    MOTO: { value: 1, label: 'MOTO' },
    PROGRESA: { value: 2, label: 'PROGRESA' },
    CULTIVA: { value: 3, label: 'CULTIVA' },
    CARGA: { value: 4, label: 'CARGA' },
    RENOVACIONES: { value: 5, label: 'RENOVACIONES' },
    MOTOCARRO: { value: 6, label: 'MOTOCARRO' },
    SEGUROS: { value: 7, label: 'SEGUROS' },
    MOTO_COMPROMISO_VALLE: { value: 8, label: 'MOTO COMPROMISO VALLE' },
    PROGRESA_COMPROMISO_VALLE: {
        value: 9,
        label: '  PROGRESA COMPROMISO VALLE',
    },
};

/* Defining a constant called SUBPRODUCTOS. */
export const SUBPRODUCTOS = {
    MOTO: { value: 2, label: 'MOTO', gygCode: 1 },
    PROGRESA: { value: 3, label: 'PROGRESA', gygCode: 10 },
    CULTIVA: { value: 6, label: 'CULTIVA', gygCode: 25 },
    PROGRESA_PREFERENCIAL: {
        value: 8,
        label: 'PROGRESA PREFERENCIAL',
        gygCode: 12,
    },
    PROGRESA_RENOVACION: {
        value: 10,
        label: 'PROGRESA RENOVACIÓN',
        gygCode: 11,
    },
    CULTIVA_RENOVACION: { value: 12, label: 'CULTIVA RENOVACIÓN', gygCode: 28 },
    CULTIVA_PREFERENCIAL: { value: 14, label: 'CULTIVA', gygCode: 29 },
    CARGA: { value: 17, label: 'CARGA', gygCode: 40 },
    PROGRESA_REACTIVACION: {
        value: 18,
        label: 'PROGRESA REACTIVACIÓN',
        gygCode: 19,
    },
    MOTO_REFINANCIACION: {
        value: 19,
        label: 'MOTO REFINANCIACIÓN',
        gygCode: 2,
    },
    MOTO_RESTRUCTURACION: {
        value: 20,
        label: 'MOTO RESTRUCTURACIÓN',
        gygCode: 4,
    },
    PROGRESA_REFINANCIACION: {
        value: 21,
        label: 'PROGRESA REFINANCIACIÓN',
        gygCode: 13,
    },
    PROGRESA_RESTRUCTURACION: {
        value: 22,
        label: 'PROGRESA RESTRUCTURACIÓN',
        gygCode: 14,
    },
    PROGRESA_RENOVA_REFINANCIACION: {
        value: 23,
        label: 'PROGRESA RENOVA REFINANCIACIÓN',
        gygCode: 15,
    },
    PROGRESA_RENOVA_RESTRUCTURACION: {
        value: 24,
        label: 'PROGRESA RENOVA RESTRUCTURACIÓN',
        gygCode: 16,
    },
    PROGRESA_PREFE_REFINANCIACION: {
        value: 25,
        label: 'PROGRESA PREFE REFINANCIACIÓN',
        gygCode: 17,
    },
    PROGRESA_PREFE_RESTRUCTURACION: {
        value: 26,
        label: 'PROGRESA PREFE RESTRUCTURACIÓN',
        gygCode: 18,
    },
    CULTIVA_RENOVA_REFINANCIACION: {
        value: 27,
        label: 'CULTIVA RENOVA REFINANCIACION',
        gygCode: 21,
    },
    CULTIVA_RENOVA_RESTRUCTURACION: {
        value: 28,
        label: 'CULTIVA RENOVA RESTRUCTURACIÓN',
        gygCode: 22,
    },
    CULTIVA_PREFE_REFINANCIACION: {
        value: 29,
        label: 'CULTIVA PREFE REFINANCIACIÓN',
        gygCode: 23,
    },
    CULTIVA_PREFE_RESTRUCTURACION: {
        value: 30,
        label: 'CULTIVA PREFE RESTRUCTURACIÓN',
        gygCode: 24,
    },
    CULTIVA_REFINANCIACION: {
        value: 31,
        label: 'CULTIVA REFINANCIACIÓN',
        gygCode: 26,
    },
    CULTIVA_RESTRUCTURACION: {
        value: 32,
        label: 'CULTIVA RESTRUCTURACIÓN',
        gygCode: 27,
    },
    CARGA_REFINANCIACION: {
        value: 33,
        label: 'CARGA REFINANCIACIÓN',
        gygCode: 41,
    },
    CARGA_RESTRUCTURACION: {
        value: 34,
        label: 'CARGA RESTRUCTURACIÓN',
        gygCode: 42,
    },
    MOTOCARRO_REFINANCIACION: {
        value: 35,
        label: 'MOTOCARRO REFINANCIACIÓN',
        gygCode: 46,
    },
    MOTOCARRO_RESTRUCTURACION: {
        value: 36,
        label: 'MOTOCARRO RESTRUCTURACIÓN',
        gygCode: 47,
    },
    REACTIVA_REFINANCIACION: {
        value: 37,
        label: 'REACTIVA REFINANCIACIÓN',
        gygCode: 31,
    },
    REACTIVA_RESTRUCTURACION: {
        value: 38,
        label: 'REACTIVA RESTRUCTURACIÓN',
        gygCode: 32,
    },
    CARGA_USADOS: { value: 40, label: 'CARGA USADOS', gygCode: 218 },
    MOTO_RENOVACION: {
        value: 41,
        label: 'MOTO RENOVACIÓN',
        gygCode: 5,
    },
    MOTOCARRO_PASAJEROS: {
        value: 42,
        label: 'MOTOCARRO PASAJEROS',
        gygCode: 48,
    },
    MOTOCARRO_CARGA: { value: 43, label: 'MOTOCARRO CARGA', gygCode: 45 },
    CARGA_RENOVACION: {
        value: 47,
        label: 'CARGA RENOVACIÓN',
        gygCode: 43,
    },
    CARGA_2_0: {
        value: 113,
        label: 'CARGA 2.0',
        gygCode: 60,
    },
    CARGA_ESPECIALES: { value: 114, label: 'CARGA ESPECIALES', gygCode: 45 },
    CARGA_PASAJEROS: { value: 115, label: 'CARGA PASAJEROS', gygCode: 9999 },
    CARGA_SEGURA: { value: 116, label: 'CARGA SEGURA', gygCode: 50 },
    CARGA_ESPECIALES_2_0: {
        value: 117,
        label: 'CARGA ESPECIALES 2.0',
        gygCode: 9999,
    },
    CARGA_PASAJEROS_2_0: {
        value: 118,
        label: 'CARGA PASAJEROS 2.0',
        gygCode: 9999,
    },
    MOTO_COMPROMISO_VALLE: {
        value: 119,
        label: 'MOTO COMPROMISO VALLE',
        gygCode: 9999,
    },
    PROGRESA_COMPROMISO_VALLE: {
        value: 120,
        label: 'MOTO COMPROMISO VALLE',
        gygCode: 9999,
    },
    PROGRESA_COMPROMISO_VALLE_RECONSTRUYE: {
        value: 136,
        label: 'PROGRESA COMPROMISO VALLE RECONSTRUYE',
        gygCode: 9999,
    },
    MOTOCARRO_RECONSTRUYE: {
        value: 135,
        label: 'MOTOCARRO RECONSTRUYE',
        gygCode: 9999,
    },
    CARGA_RECONSTRUYE: {
        value: 134,
        label: '  CARGA RECONSTRUYE',
        gygCode: 9999,
    },
    CAMPO_RECONSTRUYE: {
        value: 133,
        label: 'CAMPO RECONSTRUYE',
        gygCode: 9999,
    },
    PROGRESA_RECONSTRUYE: {
        value: 132,
        label: 'PROGRESA RECONSTRUYE',
        gygCode: 9999,
    },
    MOTO_RECONSTRUYE: {
        value: 131,
        label: 'MOTO RECONSTRUYE',
        gygCode: 9999,
    },
    CARGA_PASAJEROS_RECONSTRUYE: {
        value: 139,
        label: 'CARGA PASAJEROS RECONSTRUYE',
        gygCode: 9999,
    },
    CARGA_ESPECIALES_RECONSTRUYE: {
        value: 138,
        label: 'CARGA ESPECIALES RECONSTRUYE',
        gygCode: 9999,
    },
    CARGA_20_RECONSTRUYE: {
        value: 137,
        label: 'CARGA 2.0 RECONSTRUYE',
        gygCode: 9999,
    },
    MOTO_COMPROMISO_VALLE_RECONSTRUYE: {
        value: 130,
        label: 'MOTO COMPROMISO VALLE RECONSTRUYE',
        gygCode: 9999,
    },
};

export const STEP_DOWNLOAD_DOCUMENT = {
    STARTSIGN: { name: 'STARTSIGN', value: 4 },
    STARTDOCUMENTDOWNLOAD: { name: 'STARTDOCUMENTDOWNLOAD', value: 4 },
    PREGUNTAS_RETO: { name: 'PREGUNTAS_RETO', value: 4 },
    // QUESTION_TWO: 3,
    OTP: { name: 'OTP', value: 4 },
    DOWNLOAD_DOCUMENT: { name: 'DOWNLOAD_DOCUMENT', value: 4 },
    FACE_ID: { name: 'FACE_ID', value: 4 },
    FOTO_SELFIE: { name: 'FOTO_SELFIE', value: 4 },
    FOTO_CEDULA: { name: 'FOTO_CEDULA', value: 4 },
    OTP_EXTERNO: { name: 'OTP_EXTERNO', value: 4 },
};

export const SALERT_CUSTOM_CLASS = {
    container: 'cotainer-slaert',
    title: 'title-salert',
    confirmButton: 'confirm-button-salert',
    cancelButton: 'cancel-button-salert',
};

export const PROPERTIES = {
    ID_NUMBER: { required: true, maxLength: 10, minLength: 6 },
    FIRST_NAME: {
        required: true,
        maxLength: 25,
        minLength: 2,
    },
    SECOND_NAME: {
        maxLength: 25,
        minLength: 2,
    },
    FIRST_SURNAME: {
        required: true,
        maxLength: 25,
        minLength: 2,
    },
    SECOND_SURNAME: {
        maxLength: 25,
        minLength: 2,
    },

    BUSINESS_TYPE: { required: true, maxLength: 200, minLength: 2 } /*********/,
    JOB_POSITION: { required: true, maxLength: 200, minLength: 3 },

    /** */
    JOB_NAME: { maxLength: 50, minLength: 3 },
    // BUSINESS_NAME: { maxLength: 30, minLength: 3 },
    /** */
    STRATUM: { required: true, max: 6, min: 1 },

    /** */
    ANTIQUITY: { max: 900, min: 1 },
    //LOCAL_ANTIQUITY: { required: true, max: 900, min: 1 },
    //SENIORITY_IN_RESIDENCE: { required: true, max: 900, min: 1 },
    //SENIORITY_IN_THE_COMPANY: { required: true, max: 900, min: 1 },
    //SENIORITY_AT_WORK: { required: false, max: 900, min: 1 },
    /** */

    HOUSEHOLD_MEMBERS: { max: 50, min: 1 },
    PEOPLE_IN_CHARGE: { max: 10, min: 0 },
    NUMBER_OF_CHILDREN: { max: 20, min: 0 },

    EXPERIENCE: { maxLength: 200, minLength: 2 },
    ACTIVITY: { maxLength: 200, minLength: 2 },
    DESCRIPTION: { maxLength: 200, minLength: 2 },

    PERMANENT_EMPLOYES: { required: true, max: 50, min: 0 },
    TEMPORARY_EMPLOYES: { required: true, max: 50, min: 0 },

    /** */
    ECONOMIC_SECTOR: { maxLength: 200, minLength: 3 },
    ECONOMIC_ACTIVITY_DESCRIPTION: { maxLength: 200, minLength: 3 },
    /** */

    ADDRESS: { required: true, maxLength: 200, minLength: 2 },
    PHONE: {
        required: true,
        regExp: /[2-8][0-9]{2}-[0-9]{4}|[2-8][0-9]{6}/,
    },
    CELL_PHONE: {
        required: true,
        regExp: /^(300|301|302|303|304|324|305|310|311|312|313|314|320|321|322|323|315|316|317|318|319|319|350|351|302|323|324|324|333)-[0-9]{3}-[0-9]{4}|^(300|301|302|303|304|324|305|310|311|312|313|314|320|321|322|323|315|316|317|318|319|319|350|351|302|323|324|324|333)[0-9]{7}/,
    },
    DESTINATION_RESOURCES: { minLength: 3, maxLength: 200 },
    INVENTORY_ROTATE: { required: true, maxLength: 3 },
    FINANCIAL_LIQUIDITY: { required: true, maxLength: 3 },
    REAL_ESTATE_ADDRESS: {
        required: true,
        maxLength: 200,
        minLength: 2,
    } /********/,

    // MODEL: { required: true, maxLength: 4, minLength: 4 },
    VEHICLE_MODEL: {
        maxLength: 4,
        minLength: 4,
        min: 2019,
        max: 2050,
    },
    VEHICLE_CHASSIS: {
        maxLength: 20,
        minLength: 4,
    },
    VEHICLE_ENGINE: {
        maxLength: 30,
        minLength: 3,
    },
    VEHICLE_COLOR: {
        maxLength: 150,
        minLength: 3,
    },
    VEHICLE_SERIE: {
        maxLength: 20,
        minLength: 3,
    },
    VEHICLE_PLATE: { maxLength: 6, minLength: 6 },
    //LICENSE_PLATE: { required: true, maxLength: 7, minLength: 6 },

    WARRANTY_FNG: { required: true, maxLength: 10, minLength: 7 },
    DESCRIPTION_ACTIVITY: { required: true, maxLength: 200 },
    OBSERVATION: { required: true, maxLength: 1000, minLength: 3 },
    COST_OF_SALE: { required: true, maxValueString: 100 },
    INCOME: { maxLength: 12, minLength: 1 },
    SALARY: { maxLength: 12, minLength: 1 },

    BANK_ACCOUNT_NUMBER: {
        required: true,
        maxLength: 19,
    },
    PAYDAY: { required: true, max: 21, min: 1 },

    SAFE_PERCENTAGE: { required: true, maxValueString: 100 },
    REFERENCE_LOCATION: { maxLength: 200, minLength: 5 },

    BUSINESS_LOCATION_REFERENCE: { maxLength: 200, minLength: 5 },

    EMAIL: {
        required: false,
        regExp: /^((?!tiene|TIENE|CORREO|correo)[a-zA-Z0-9.\-_]){3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    },
    DAYS_WEEK: { max: 7, min: 1 },
    AGE_CLIENT: { max: 69, min: 18 },
    AGE_CODEBTOR: { max: 74, min: 18 },
    FASECOLDA: { maxLength: 8, minLength: 8 },
};

export const URL_BASE = {
    USERS_URL: { value: '/globals/users/' },
    CITY_URL: { value: '/globals/ciudades/' },
    SUBPRODUCTO_URL: { value: '/globals/subproducto/' },
};

export const URL = {
    EMPTY_URL: { value: '#' },
    BARRIOS: { value: '/globals/barrios/?is_active=true' },
    MARCAS: { value: '/globals/marcas/' },
    LINEA: { value: '/globals/marcas_lineas/' },
    CONCESIONARIOS: { value: '/globals/concesionarios/?is_active=true' },
    SUBPRODUCTO: { value: '/globals/subproducto/' },
    ALIADOS: {
        value: `${URL_BASE.USERS_URL.value}?groups=11,25&is_active=true`,
    },
    EJECUTIVOS: {
        value: `${URL_BASE.USERS_URL.value}?groups=3&is_active=true`,
    },
    OFICINAS: { value: '/globals/oficinas/' },
    CIUDADES: { value: URL_BASE.CITY_URL.value },
    CIUDADES_POR_DEPARTAMENTO: {
        value: `${URL_BASE.CITY_URL.value}?departamento={0}`,
    },
    ACTIVIDAD_ECONOMICA: { value: '/globals/ciiu/' },
    FNG_PRODUCTO: { value: '/globals/fng_productos/' },
    FNG_PORCENTAJE: { value: '/globals/fng_porcentajes/' },
    BANCOS: { value: '/globals/bancos/' },
    SUBPRODUCTO_POR_PRODUCTO: {
        value: `${URL_BASE.SUBPRODUCTO_URL.value}?producto={0}`,
    },
    CARROCERIAS: { value: '/globals/carrocerias/' },
    CLASES_VEHICULOS: { value: '/globals/clases_vehiculos/' },
    TIPO_CERTIFICADO: { value: '/globals/tipo_certificado_credito/' },
    PLAZOS_SOLICITADO: { value: '/calculadora/plazo_subproducto_solicitud/' },
    EMISORA_URL: { value: '/globals/emisoras/' },
    SUBPRODUCTO_POR_PRODUCTO_SEGUROS: {
        value: `${URL_BASE.SUBPRODUCTO_URL.value}?producto=7`,
    },
    DIAS_PAGO: { value: '/globals/dias_pago/' },
    TIPO_DOCS_GVM: { value: '/globals/gmv_tipo_documentos/' },
    TIPO_VEHICULOS_POR_SUBPRODUCTO: { value: '/globals/tipo_vehiculos/' },
    SUBPRODUCTO_LEVANTAMIENTO_DE_PRENDA: {
        value: '/globals/subproducto/?producto=4,1,6',
    },
    METODO_CONSTRUCCION: { value: '/globals/metodos_construccion/' },
    REGIONALES: { value: '/globals/regionales/' },
    PRODUCTOS: { value: '/globals/productos/' },
    SEGURO_FAMILIA: {
        value: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=6',
    },
    MEDIO: { value: '/globals/medios/' },
    ORIGEN: { value: '/globals/origenes/' },
    TIPO_GARANTIAS: { value: '/globals/tipos_garantias_actas/' },
    TIPO_EXEPCIONES: { value: '/globals/tipos_excepciones_actas/' },
};

export const EMAIL = {
    SUPPORT_MESA_DE_AYUDA: { value: 0, label: 'info@uni2.com.co' },
};
export const TELEPHONE = {
    SUPPORT_MESA_DE_AYUDA: { value: 0, label: '(602) 4862591' },
};
export const WEBPAGE = {
    URL: 'www.uni2.com.co',
};

export const TEXT_ALERT = {
    ERROR_TITTLE: 'Algo no está bien...',
    SUCCESS_TITTLE: '¡Perfecto!',
    ERROR_TEXT: 'Se ha presentado un error',
    SUCCESS_TEXT: 'Operación realizada correctamente',
    WARNING_TITTLE: 'Advertencia',
    WARNING_TEXT: 'Se ha presentado una novedad en el proceso',
    INFO_TITTLE: 'Información',
};

export const NOTIFICATION_MANAGER_TYPE = {
    WARNING: 'Advertencia',
    SUCCESS: '¡Éxito!',
    ERROR: 'Error',
    INFO: 'Información',
};

export const CONTACT_SUPPORT = {
    UNI2: '573203546546',
    CUSTOMER_SERVICE: '573176386036',
    MESSAGE:
        '¡Hola! Necesito un poco de ayuda en la plataforma de UNI2. ¿Podrías orientarme? ¡Gracias!',
};

export const REPRESENTATIVE_NAMES = {
    GENERAL_NAME: 'UNI2',
    SOCIAL_REASON: 'UNI2 Microcrédito S.A.S.',
    COMERCIAL_NAME: 'UNI2 Microcrédito',
};

export const EMPLOYEE_PRODUCTS = {
    LIBRE_INVERSIÓN: { value: 1, label: 'LIBRE INVERSIÓN' },
    EDUCATIVO: { value: 2, label: 'EDUCATIVO' },
};

export const VIDEO_CONSTRAINTS_RECORD_VISIT_MODAL = {
    width: 700,
    height: 700,
    facingMode: 'user',
};
export const FACING_MODE_USER = 'user';
export const FACING_MODE_ENVIRONMENT = 'environment';

export const URL_IMG_RECORD_VISIT =
    '/assets/img/RecordVisit/mapsCoordsCamera.svg';

export const PHOTO_NAME_RECORD_VISIT = 'webcamPhotoRecordVisit';

export const REACT_APP_GOOGLE_MAPS_API_KEY =
    'AIzaSyAbWqJ8j9P94i9TZp3EU-cYZQzCtAGfSt8';

/***https://snazzymaps.com/ || https://stylist.atlist.com/# */
/**https://developers.google.com/maps/documentation/javascript/style-reference?hl=es-419 */
export const MAP_OPTIONS = {
    mapStyles: [
        {
            featureType: 'administrative.locality',
            elementType: 'all',
            stylers: [
                {
                    hue: '#2c2e33',
                },
                {
                    saturation: 7,
                },
                {
                    lightness: 19,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    saturation: '-3',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#f39247',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
                {
                    hue: '#ffffff',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
                {
                    hue: '#ffffff',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.school',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f39247',
                },
                {
                    saturation: '0',
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#ff6f00',
                },
                {
                    saturation: '100',
                },
                {
                    lightness: 31,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#f39247',
                },
                {
                    saturation: '0',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
                {
                    hue: '#008eff',
                },
                {
                    saturation: -93,
                },
                {
                    lightness: 31,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#f3dbc8',
                },
                {
                    saturation: '0',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    hue: '#bbc0c4',
                },
                {
                    saturation: -93,
                },
                {
                    lightness: -2,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: -90,
                },
                {
                    lightness: -8,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: 10,
                },
                {
                    lightness: 69,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: -78,
                },
                {
                    lightness: 67,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
    ],
    mapStyle2: [
        {
            featureType: 'all',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    saturation: 36,
                },
                {
                    color: '#000000',
                },
                {
                    lightness: 40,
                },
            ],
        },
        {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#000000',
                },
                {
                    lightness: 16,
                },
            ],
        },
        {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    lightness: 20,
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 17,
                },
                {
                    weight: 1.2,
                },
            ],
        },
        {
            featureType: 'administrative.province',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#e3b141',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#e0a64b',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#0e0d0a',
                },
            ],
        },
        {
            featureType: 'administrative.neighborhood',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#d1b995',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 20,
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 21,
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#12120f',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
                {
                    lightness: '-77',
                },
                {
                    gamma: '4.48',
                },
                {
                    saturation: '24',
                },
                {
                    weight: '0.65',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    lightness: 29,
                },
                {
                    weight: 0.2,
                },
            ],
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f6b044',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#4f4e49',
                },
                {
                    weight: '0.36',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#c4ac87',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#262307',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#a4875a',
                },
                {
                    lightness: 16,
                },
                {
                    weight: '0.16',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#deb483',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 19,
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#0f252e',
                },
                {
                    lightness: 17,
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#080808',
                },
                {
                    gamma: '3.14',
                },
                {
                    weight: '1.07',
                },
            ],
        },
    ],
    mapStyle3: [
        {
            featureType: 'landscape',
            stylers: [
                {
                    saturation: -100,
                },
                {
                    lightness: 60,
                },
            ],
        },
        {
            featureType: 'road.local',
            stylers: [
                {
                    saturation: -100,
                },
                {
                    lightness: 40,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'transit',
            stylers: [
                {
                    saturation: -100,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'administrative.province',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'water',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: 30,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ef8c25',
                },
                {
                    lightness: 40,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#b6c54c',
                },
                {
                    lightness: 40,
                },
                {
                    saturation: -40,
                },
            ],
        },
        {
            featureType: 'poi.business',
            elementType: 'labels.icon',
            stylers: [
                {
                    color: '#84552e',
                },
                {
                    lightness: 40,
                },
                {
                    saturation: -40,
                },
            ],
        },
        {
            featureType: 'poi.business',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#84552e',
                },
                {
                    lightness: 40,
                },
                {
                    saturation: -40,
                },
            ],
        },
        {},
    ],
    mapStyleOrange: [
        {
            featureType: 'administrative.locality',
            elementType: 'all',
            stylers: [
                {
                    hue: '#2c2e33',
                },
                {
                    saturation: 7,
                },
                {
                    lightness: 19,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    saturation: '-3',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#f39247',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
                {
                    hue: '#ffffff',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
                {
                    hue: '#ffffff',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.school',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f39247',
                },
                {
                    saturation: '0',
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#ff6f00',
                },
                {
                    saturation: '100',
                },
                {
                    lightness: 31,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#f39247',
                },
                {
                    saturation: '0',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
                {
                    hue: '#008eff',
                },
                {
                    saturation: -93,
                },
                {
                    lightness: 31,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#f3dbc8',
                },
                {
                    saturation: '0',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    hue: '#bbc0c4',
                },
                {
                    saturation: -93,
                },
                {
                    lightness: -2,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: -90,
                },
                {
                    lightness: -8,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: 10,
                },
                {
                    lightness: 69,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: -78,
                },
                {
                    lightness: 67,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
    ],
    mapStyleOrange2: [
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                { color: '#ffc194' },
                { visibility: 'on' },
                { saturation: 0 },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#ffffff',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
                { color: '#f0fff4' },
                { visibility: 'on' },
                { saturation: 0 },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#e6e6e6',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
                { color: '#a1a1a1' },
                { visibility: 'on' },
                { saturation: 0 },
            ],
        },
        {
            featureType: 'water',
            elementType: '',
            stylers: [
                { color: '#dbf6ff' },
                { visibility: 'on' },
                { saturation: 0 },
            ],
        },
        {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'transit.station',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'all',
            elementType: 'labels.text',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [{ visibility: 'on' }],
        },
    ],
    mapStyleOrange3: [
        {
            featureType: 'administrative.locality',
            elementType: 'all',
            stylers: [
                {
                    hue: '#2c2e33',
                },
                {
                    saturation: 7,
                },
                {
                    lightness: 19,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    saturation: '-3',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#f39247',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
                {
                    hue: '#ffffff',
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#ff6f00',
                },
                {
                    saturation: '100',
                },
                {
                    lightness: 31,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#f39247',
                },
                {
                    saturation: '0',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
                {
                    hue: '#008eff',
                },
                {
                    saturation: -93,
                },
                {
                    lightness: 31,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#f3dbc8',
                },
                {
                    saturation: '0',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    hue: '#bbc0c4',
                },
                {
                    saturation: -93,
                },
                {
                    lightness: -2,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: -90,
                },
                {
                    lightness: -8,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: 10,
                },
                {
                    lightness: 69,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    hue: '#e9ebed',
                },
                {
                    saturation: -78,
                },
                {
                    lightness: 67,
                },
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'transit.station',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'all',
            elementType: 'labels.text',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [{ visibility: 'on' }],
        },
    ],
};

export const STATUS_LIVENESS = {
    CANCELED: 'CANCELED',
    ERROR: 'ERROR',
    IS_ALIVE: 'IS_ALIVE',
    IS_NOT_ALIVE: 'IS_NOT_ALIVE',
};

export const FINANCIAL_SOLUTIONS = {
    CAMBIO_DE_FECHA: {
        value: 1,
        label: 'CAMBIO DE FECHA',
    },
    CONDONACION: {
        value: 2,
        label: 'CONDONACION',
    },
    CONDONACION_RECUPERADOS: {
        value: 3,
        label: 'CONDONACION RECUPERADOS',
    },
    MODIFICACION_FINANCIERA: {
        value: 4,
        label: 'MODIFICACION FINANCIERA',
    },
    MODIFICACION_FINANCIERA_MOTO_RECUPERADA: {
        value: 5,
        label: 'MODIFICACION FINANCIERA MOTO RECUPERADA',
    },
    MODIFICACION_FINANCIERA_VEHICULO_RECUPERADO: {
        value: 6,
        label: 'MODIFICACION FINANCIERA VEHÍCULO RECUPERADO',
    },
    MODIFICACION_RECLAMACION_SURA: {
        value: 7,
        label: 'MODIFICACION RECLAMACION SURA',
    },
    NORMALIZACION: {
        value: 8,
        label: 'NORMALIZACION',
    },
    PERIODO_DE_GRACIA: {
        value: 9,
        label: 'PERIODO DE GRACIA',
    },
    RECLAMACION_GC_CON_COBRO: {
        value: 10,
        label: 'RECLAMACION GC CON COBRO',
    },
    RECLAMACION_GC_SIN_COBRO: {
        value: 11,
        label: 'RECLAMACION GC SIN COBRO',
    },
    RECLAMACION_SURA: {
        value: 12,
        label: 'RECLAMACION SURA',
    },
};

export const TEST_IDS = {
    EMAIL_INPUT: 'emailInput',
    PASSWORD_INPUT: 'passwordInput',
};

/***
Extension MIME Type

.doc      application/msword
.dot      application/msword

.docx     application/vnd.openxmlformats-officedocument.wordprocessingml.document
.dotx     application/vnd.openxmlformats-officedocument.wordprocessingml.template
.docm     application/vnd.ms-word.document.macroEnabled.12
.dotm     application/vnd.ms-word.template.macroEnabled.12

.xls      application/vnd.ms-excel
.xlt      application/vnd.ms-excel
.xla      application/vnd.ms-excel

.xlsx     application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
.xltx     application/vnd.openxmlformats-officedocument.spreadsheetml.template
.xlsm     application/vnd.ms-excel.sheet.macroEnabled.12
.xltm     application/vnd.ms-excel.template.macroEnabled.12
.xlam     application/vnd.ms-excel.addin.macroEnabled.12
.xlsb     application/vnd.ms-excel.sheet.binary.macroEnabled.12
.csv      text/csv

.ppt      application/vnd.ms-powerpoint
.pot      application/vnd.ms-powerpoint
.pps      application/vnd.ms-powerpoint
.ppa      application/vnd.ms-powerpoint

.pptx     application/vnd.openxmlformats-officedocument.presentationml.presentation
.potx     application/vnd.openxmlformats-officedocument.presentationml.template
.ppsx     application/vnd.openxmlformats-officedocument.presentationml.slideshow
.ppam     application/vnd.ms-powerpoint.addin.macroEnabled.12
.pptm     application/vnd.ms-powerpoint.presentation.macroEnabled.12
.potm     application/vnd.ms-powerpoint.template.macroEnabled.12
.ppsm     application/vnd.ms-powerpoint.slideshow.macroEnabled.12

.mdb      application/vnd.ms-access
**/
